module.exports = __webpack_public_path__ + "img/2002pigc.664ef6ed.png";